import { useState } from 'react'
import { Button } from '@mui/material'
import SelectWithExternalLabel from './ui/SelectWithExternalLabel'
import TextArea from './ui/TextArea.js'
import Modal from './Modal'
import { useGeneral } from '../context/general'
import axios from 'axios'

export default function MoreDataForm({open, setMoreDataFormVisibility}) {
    const [optionSelected, setOptionSelected] = useState('Scout more data')
    const [message, setMessage] = useState('')
    const options = [{value:'Scout more data', name:'Scout more data'},{value:'A problem with the data', name:'A problem with the data'},{value:'New data idea', name:'New data idea'}]
    const { setPopupAlert } = useGeneral()

    const updateOptionSelected = (e) => {
        setOptionSelected(e.value)
    }

    const updateMessage = (e) => {
        setMessage(e.target.value)
    }

    const closeForm = () => {
        setMoreDataFormVisibility(false)
        setMessage('')
        setOptionSelected('Scout more data')
    }

    const sendFormAsEmail = () => {
        if (message){
            // fetch('/api/sendEmailContactUs', {
            //     method: 'POST',
            //     headers: { 'Content-Type': 'application/json' },
            //     body: JSON.stringify({
            //         topic: optionSelected,
            //         message,
            //     })
            // })
            axios({
                method: 'POST',
                url: '/api/sendEmailContactUs',
                data: {topic: optionSelected,message}
            })
            .then(res => res.data)
            .then(res => {
                if (res.emailSent){
                    setPopupAlert('success', 'Message was sent. Thanks for the feedback!')
                } else {
                    setPopupAlert('error', 'Something went wrong, message was not sent.')
                }
            })                
        } else {
            setPopupAlert('error', "Message wasn't sent. You didn't fill the form.")
        }
        closeForm()
    }

    const form = (
            <>
                <SelectWithExternalLabel label='Choose one of the options' options={options} value={optionSelected} setValue={updateOptionSelected}/>
                <TextArea label='Add comment' value={message} onChangeFunc={updateMessage}/>
            </>
    )
    
    
    const buttons = [
        <Button key="cancel" variant="outlined" onClick={closeForm}> Cancel </Button>,
        <Button key="submit" variant="contained" color="active" onClick={sendFormAsEmail}> Submit Request </Button>
    ]

    
    return (
        <Modal open={open} handleClose={closeForm} title='Data Questions' buttons={buttons} alert={alert}>
            {form}
        </Modal>
    )
}